import React from 'react'
import Layout from '../Components/Layout/Layout'
import AboutComponent from '../Components/AboutComponent'

const About = () => {
  return (
    <>
    <Layout>
        <AboutComponent />
    </Layout>
    </>
  )
}

export default About


